<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <SellProductFiltersComponent
                    ref="sell-product-search"
                    @searchPressed="getProductRestockShop"
                    @subfamilyLoaded="getProductRestockShop"
                    :enableFieldType="false"
                    :showErrors="true"
                    :showAvgSell="true"
                    preselectFamily
                ></SellProductFiltersComponent>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <div>
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="products"
                        :loading="loading"
                        item-key="cod_articolo"
                        class="elevation-1"
                        :items-per-page="50"
                        show-select
                        :footer-props="{
                            'items-per-page-options': [50, 100, 200, 500, -1],
                        }"
                        dense
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    small
                                    dark
                                    class="mb-2"
                                    @click="exportData()"
                                >
                                    Esporta
                                    <v-icon small> download </v-icon>
                                </v-btn>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.cod_articolo="{ item }">
                            <router-link
                                target="_blank"
                                :to="{
                                    name: 'product',
                                    query: {
                                        id: item.cod_articolo,
                                    },
                                }"
                            >
                                {{ item.cod_articolo }}
                            </router-link>
                        </template>
                        <template
                            v-for="shop in shops"
                            v-slot:[`item.giacenza_${shop.id}`]="{ item }"
                        >
                            <slot
                                :name="`item.giacenza_${shop.id}`"
                                :values="item"
                            >
                                {{
                                    calcRiordino(
                                        item.lotto_riordino,
                                        item.cod_articolo,
                                        shop.id
                                    )
                                }}
                            </slot>
                        </template>
                        <template v-slot:item.totalone="{ item }">
                            {{
                                calcoloTotalone(
                                    item.lotto_riordino,
                                    item.cod_articolo
                                )
                            }}
                        </template>
                    </v-data-table>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped lang="scss"></style>
<script>
import requests from "../../requests";
import SellProductFiltersComponent from "../../components/SellProductFiltersComponent.vue";
import _ from "lodash";
import $ from "jquery";

let shopById = {};
export default {
    name: "product-restock-shop",
    components: { SellProductFiltersComponent },
    data: () => {
        return {
            headers: [],
            selected: [],
            loading: false,
            shops: [],
            products: [],
            giacenze: [],
            original_data: [],
            order: {},
            reorder_days: 60,
            desc_search: "",
            flag_riordino: false,
            filtra_riordino: false,
        };
    },

    async mounted() {
        console.log("ProductRestockShop Mounted.");

        const req = await requests.getPercCasamadre();
        let perc_casamadre = req.data.perc_casamadre;

        const req2 = await this.getShops();
        let s = _.filter(req2.data, { shop_type: "J" });
        s.unshift({
            id: -1,
            description: "CASA MADRE",
            type: "shop",
            shop_type: "J",
            lotto_riordino: perc_casamadre
        })
        this.shops = s;
        shopById = _.keyBy(this.shops, "id");

        this.setHeaders(this.shops);
    },
    methods: {
        imagePath(prodId) {
            if (!this.error) {
                let normId = prodId.replace("/", "_") + ".jpg";
                return "/images/catalog/lower/" + normId;
            } else {
                return "no_image.jpg";
            }
        },
        getShops() {
            return requests.getShopList();
        },
        filtraRiordino(checked) {
            if (checked) {
                this.data = _.filter(this.original_data, (o) => {
                    return o.lotto_riordino > 0;
                });
            } else this.data = this.original_data;
        },
        filterDesc(str) {
            this.data = _.filter(this.original_data, (o) => {
                if (_.isEmpty(str)) return true;
                return _.lowerCase(o.ar_descr).includes(_.lowerCase(str));
            });
        },
        getProductRestockShop(filters) {
            filters["reorder_days"] = this.reorder_days;
            this.loading = true;
            requests.getProductRestockShop(filters).then((res) => {
                this.products = res.data.products;
                this.giacenze = res.data.giacenze;
                //this.original_data = _.cloneDeep(res.data);
                this.loading = false;
            });
        },
        getColor(days) {
            if (days <= 30) return "red";
            else if (days > 30 && days <= 90) return "orange";
            else return "green";
        },
        exportData() {
            let filters = this.$refs["sell-product-search"].getFilters();
            filters["reorder_days"] = this.reorder_days;
            filters["selected"] = _.map(this.selected, "cod_articolo");
            console.log("Opening...", "/api/product-reorder-export?" + $.param(filters))
            window.open(
                "/api/product-reorder-export?" + $.param(filters),
                "_blank"
            );
        },
        calcoloGiornoRiordino(qty_media_giornaliera) {
            return Math.ceil(
                parseInt(this.reorder_days) * parseFloat(qty_media_giornaliera)
            );
        },
        setHeaders(shops) {
            let a = [
                {
                    text: "Cod Forn",
                    sortable: true,
                    value: "xx_codarfo",
                },
                {
                    text: "Cod Art",
                    sortable: true,
                    value: "cod_articolo",
                },
                {
                    text: "Desc",
                    sortable: true,
                    value: "ar_descr",
                },
                { text: "Barcode", value: "bc_code" },
            ];

            _.each(shops, (shop) => {
                a.push({
                    text: shop.description,
                    value: "giacenza_" + shop.id,
                });
            });
            a.push({ text: "TOTALE", value: "totalone" });
            this.headers = a;
        },

        calcRiordino(lottoRiordino, cod_articolo, shopId) {
            if (
                !_.isUndefined(shopById[shopId]) &&
                !_.isUndefined(this.giacenze[cod_articolo]) &&
                !_.isUndefined(this.giacenze[cod_articolo][shopId])
            ) {
                let perc = shopById[shopId].lotto_riordino;
                let lt = Math.round(
                    lottoRiordino + (lottoRiordino * perc) / 100
                );
                let rir =
                    lt -
                    parseInt(this.giacenze[cod_articolo][shopId].tot_giacenze);
                return rir < 0 ? 0 : rir;
            }
            return 0;
        },

        calcoloTotalone(lottoRiordino, cod_articolo) {
            if (!_.isUndefined(this.giacenze[cod_articolo])) {
                let tot = 0;
                _.each(this.giacenze[cod_articolo], (negozio) => {
                    let num = this.calcRiordino(
                        lottoRiordino,
                        cod_articolo,
                        negozio.shop_id
                    );
                    if (_.isNumber(num)) tot += num;
                });
                return tot;
            }
            return 0;
        },
    },
    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    },
};
</script>
